import api from './axiosApi'
import type {
  PaginatedStoresResponse,
  StoreAttributeListResponse,
  StoreAttributeValuesResponse,
} from '@/types'

interface ListStoresParams {
  search?: string
  region?: string
  is_active?: boolean
  skip?: number
  limit?: number
}

export async function listStores(
  params: ListStoresParams = {}
): Promise<PaginatedStoresResponse> {
  const { search, region, is_active, skip = 0, limit = 20 } = params

  const response = await api.get<PaginatedStoresResponse>('/admin/stores', {
    params: {
      search: search || undefined,
      region: region || undefined,
      is_active: is_active ?? undefined,
      skip,
      limit,
    },
  })

  return response.data
}

export async function fetchStoreAttributes(): Promise<StoreAttributeListResponse> {
  const response = await api.get<StoreAttributeListResponse>(
    '/admin/stores/attributes'
  )
  return response.data
}

export async function fetchStoreAttributeValues(
  fieldName: string
): Promise<StoreAttributeValuesResponse> {
  const response = await api.get<StoreAttributeValuesResponse>(
    `/admin/stores/attributes/${fieldName}`
  )
  return response.data
}

export async function fetchPogGroups(): Promise<StoreAttributeValuesResponse> {
  const response = await api.get<StoreAttributeValuesResponse>(
    '/admin/stores/pog-groups'
  )
  return response.data
}
